import { Forecast } from './Forecast';
export default Forecast;
